export function normalizeAutoCloseLateReg(value: unknown): number | null {
  if (value === null || value === undefined) {
    return null;
  }
  const lateRegDuration = Number(value);
  if (!Number.isFinite(lateRegDuration) || lateRegDuration < 0) {
    return null;
  }
  if (lateRegDuration === 0) {
    return 0;
  }
  return Math.min(999, Math.round(lateRegDuration));
}

export function pickNotificationOptionsSource(
  stored: unknown,
  localRaw: string | null
): "stored" | "local" | "default" {
  if (stored && typeof stored === "object" && !Array.isArray(stored)) {
    return "stored";
  }
  if (localRaw) {
    return "local";
  }
  return "default";
}
